import React, { useContext } from 'react';
import { Divider, Paper, Stack, Typography } from '@mui/material';
import DataContext from '../../context/DataProvider/DataContext';
import StartSoon from '../../components/StartSoonAgent';
import BirthdaysOfMonth from '../../components/BirthdaysOfMonth';
import { AgentStatus, Agent } from '../../types/Agent.types';

function DashboardPage() {
  const context = useContext(DataContext);

  const BeraterInsgesamt = context.agents.length;
  const ActiveBerater = context.agents.filter((agent: Agent) => agent.status.id === AgentStatus.active).length;
  const GekündigteBerater = context.agents.filter((agent: Agent) => agent.status.id === AgentStatus.dismissed).length;
  const InBearbeitungBerater = context.agents.filter(
    (agent: Agent) => agent.status.id === AgentStatus.inProcess,
  ).length;
  const VerloreneBerater = context.agents.filter((agent: Agent) => agent.status.id === AgentStatus.failed).length;

  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
        <Paper variant="outlined" data-testid="dashboard-kpi-total" sx={{ flex: 1, p: 2, cursor: 'default' }}>
          <Typography variant="caption" color="text.secondary">
            Berater insgesamt
          </Typography>
          <Typography variant="h6">{BeraterInsgesamt || 0}</Typography>
        </Paper>

        <Paper variant="outlined" data-testid="dashboard-kpi-active" sx={{ flex: 1, p: 2, cursor: 'default' }}>
          <Typography variant="caption" color="text.secondary">
            Aktive Berater
          </Typography>
          <Typography variant="h6">{ActiveBerater || 0}</Typography>
        </Paper>

        <Paper variant="outlined" data-testid="dashboard-kpi-in-process" sx={{ flex: 1, p: 2, cursor: 'default' }}>
          <Typography variant="caption" color="text.secondary">
            Berater in Bearbeitung
          </Typography>
          <Typography variant="h6">{InBearbeitungBerater || 0}</Typography>
        </Paper>

        <Paper variant="outlined" data-testid="dashboard-kpi-dismissed" sx={{ flex: 1, p: 2, cursor: 'default' }}>
          <Typography variant="caption" color="text.secondary">
            Gekündigte Berater
          </Typography>
          <Typography variant="h6">{GekündigteBerater || 0}</Typography>
        </Paper>

        <Paper variant="outlined" data-testid="dashboard-kpi-failed" sx={{ flex: 1, p: 2, cursor: 'default' }}>
          <Typography variant="caption" color="text.secondary">
            Verlorene Berater
          </Typography>
          <Typography variant="h6">{VerloreneBerater || 0}</Typography>
        </Paper>
      </Stack>
      <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
        <StartSoon />
        <BirthdaysOfMonth />
      </Stack>
    </Stack>
  );
}
export default DashboardPage;
